module.exports = {
  BUSINESS_MOBILE_TYPE: {
    MOBILE: 'MOBILE',
    FAX: 'FAX',
    LANDLINE: 'LANDLINE'
  },
  IDENTIFICATION_TYPE: {
    NONE: 'NONE',
    OTHERS: 'OTHERS',
    INCORPORATION_NUMBER: 'INCORPORATION_NUMBER'
  },
  BUSINESS_TAX_ID_TYPE: {
    SSN: 'SSN',
    EIN: 'EIN',
    ITIN: 'ITIN',
    VAT: 'VAT',
    FOREIGN: 'FOREIGN'
  },
  BUSINESS_RISK_RATING: {
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH'
  }
};
